import React from 'react';
import SelectField from '../../forms/_fields_v2/SelectField';
import useRouter from '../../hooks/useRouter';
import SelectFieldLinkOption from '../../forms/SelectFieldLinkOption';

export default function MobileSubNavigation({ pageLinks }) {
  const { location, history } = useRouter();

  return (
    <div className="grid grid-cols-1 gap-4 lg:hidden mb-8" hidden>
      <SelectField
        label="Page"
        value={location.pathname}
        options={{
          data: (pageLinks || []).map(function(link) {
            return {
              id: link.href,
              data: {
                name: link.name,
                count: link.count,
                highlight: link.highlight
              }
            };
          })
        }}
        optionLabel={function(datum) {
          return (
            <SelectFieldLinkOption
              name={datum.data.name}
              count={datum.data.count}
              highlight={datum.data.highlight}
            />
          );
        }}
        onChange={function(id) {
          history.push(id);
        }}
      />
    </div>
  );
}
